import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-zhuanti",
  "use": "icon-zhuanti-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhuanti\">\r\n  <path d=\"M464.6 925.4c-32 0-62.1-12.4-84.6-35.1L134.6 643.9c-46.5-46.7-46.6-122.6-0.1-169.3l315.7-316.9c43.3-43.5 124.5-69.6 185-59.5l184 30.8c35.5 5.9 68 38.5 73.9 74.2L923.8 388c10.1 60.6-15.9 142.2-59.2 185.6L548.9 890.5c-22.4 22.5-52.3 34.9-84.3 34.9 0.1 0 0.1 0 0 0z m143.2-787.5c-44.6 0-99.1 20.3-128 49.3L164.1 504.1c-30.3 30.4-30.2 79.9 0.1 110.3l245.4 246.4c14.6 14.7 34.1 22.8 55 22.8 20.7 0 40.1-8 54.6-22.6L835 544.1c33.6-33.7 55.4-102.1 47.6-149.2L852 210.1c-3-18.2-21.5-36.8-39.6-39.8l-184.1-30.8c-6.5-1.1-13.4-1.6-20.5-1.6z\" />\r\n  <path d=\"M652.6 335.6c0 11.7 4.6 22.9 12.8 31.2 8.2 8.3 19.4 12.9 31.1 13 24.3-0.1 44-19.8 43.9-44.1 0-11.7-4.6-22.9-12.8-31.2-8.2-8.3-19.4-12.9-31.1-13-11.7 0-22.9 4.7-31.1 13-8.2 8.2-12.8 19.4-12.8 31.1z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhuanti.svg
// module id = iTaP
// module chunks = 21